import React from 'react';
import Locale from '../locale/en/contactUs';

const ContactUs = () => <div className="contact-us">{Locale.text}</div>;

export default ContactUs;
